/**
 * @fileOverview View for desktop date range picker, using React component.
 * @author jzetlen
 *
 */

import invariant from 'invariant-slim';
import createRenderer from 'component-datepicker/dist/create-renderer';
import DateRangePicker from 'component-datepicker/dist/components/DateRangePicker';
import { composeStore } from './storeUtils';
import datePickerStore from './stores/base';
import mouseHandling from './stores/mouseHandling';
import keyboardHandling from './stores/keyboardHandling';
import shortcutHandling from './stores/shortcutHandling';

export function validateConfig(config) {
	invariant(config.el && config.el.nodeType, 'config.el must be a DOM node');
	invariant(
		typeof config.onDateChange === 'function',
		'config.onDateChange must be a function'
	);
}

export default function createDesktopDateRangePicker(config) {
	validateConfig(config);

	// create view renderer of shape { render, remove }
	const pickerView = createRenderer(DateRangePicker, config.el);

	// construct store from modules, right to left
	const pickerStore = composeStore([
		shortcutHandling(config),
		keyboardHandling(config),
		mouseHandling(config),
		datePickerStore(config)
	]);

	pickerStore.onUpdate(renderPicker);

	pickerStore.onPublish(submitDates);

	renderPicker();

	return pickerStore;

	function renderPicker() {
		pickerView.render(pickerStore.getState());
	}

	function submitDates(event, startDate, endDate) {
		config.onDateChange(event, { startDate, endDate });
	}
}



// WEBPACK FOOTER //
// ./view/activity/dateRangePicker/desktopView.es6